export default __webpack_public_path__ + "static/media/macbook.71262e95.svg";